import { getWorldMapObject } from '@blocksuite/affine-model';

const cachedPaths = new Map<string, Path2D>();
export function drawWorldMapObject(
  ctx: CanvasRenderingContext2D,
  kind: string,
  width: number,
  height: number,
  stroke: string,
  strokeWidth = 5,
  fill?: string,
  dashed = false
) {
  const object = getWorldMapObject(kind);
  if (!object || width <= 0 || height <= 0) return;
  ctx.save();
  const scale = Math.min(width, height) / 64;
  ctx.translate((width - 64 * scale) / 2, (height - 64 * scale) / 2);
  ctx.scale(scale, scale);
  ctx.lineWidth = (2.5 * strokeWidth) / 5;
  ctx.lineCap = 'round';
  ctx.lineJoin = 'round';
  ctx.strokeStyle = stroke;
  ctx.setLineDash(dashed ? [6, 6] : []);
  for (const part of object.paths) {
    let path = cachedPaths.get(part.d);
    if (!path) {
      path = new Path2D(part.d);
      cachedPaths.set(part.d, path);
    }
    if (fill && !part.detail) {
      ctx.fillStyle = fill;
      ctx.fill(path);
    }
    ctx.stroke(path);
  }
  ctx.restore();
}
